export const GET_ALL_COMPLETE_REQUEST = 'GET_ALL_COMPLETE_REQUEST';
export const SAVE_ALL_COMPLETE_REQUEST = 'SAVE_ALL_COMPLETE_REQUEST';
export const GET_LOCKER_DETAILS = 'GET_LOCKER_DETAILS';
export const GET_LOCKER_DOC = 'GET_LOCKER_DOC';
